const Footer = () => {
    return (
        <footer className="bg-white border-t border-black py-6">
            <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-3 gap-4 lg:gap-0">
                <div className="text-black font-semibold text-xl flex items-center justify-start">DRN</div>
                <div className="text-black/70 font-light text-sm flex items-center justify-start sm:justify-center text-center">© 2026 Deva Rahma Nugroho</div>
                <div className="text-black/70 font-light text-sm flex flex-wrap items-center justify-start lg:justify-end gap-x-4 gap-y-2">
                    <a href="https://discordapp.com/users/1121487954339176508" target="__blank" className="hover:underline">Discord</a>
                    <a href="https://github.com/deva3xd" target="__blank" className="hover:underline">Github</a>
                    <a href="https://mailto:devarn05@gmail.com" target="__blank" className="hover:underline">Gmail</a>
                    <a href="https://www.instagram.com/deva3xd_" target="__blank" className="hover:underline">Instagram</a>
                    <a href="http://linkedin.com/in/deva-rahma-nugroho" target="__blank" className="hover:underline">LinkedIn</a>
                </div>
            </div>
        </footer>
    )
}

export default Footer
